import React, { useState, useEffect } from 'react';
import styles from "../../assets/scss/pagesScss/home.module.scss";
import { bannerInfo } from '../../assets/config/config';

export default function HeroSections() {
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const imageInterval = setInterval(() => {
            setCurrentImage((prevImage) => (prevImage + 1) % bannerInfo.image.length);
        }, 3000); // Change image every 3 seconds

        return () => clearInterval(imageInterval); // Clean up the interval on unmount
    }, []);

    return (
        <section className={styles.heroSection}>
            <div className={styles.heroContent}>
                <div className={styles.leftContent}>
                    <h1>{bannerInfo.title}</h1>
                    <p>{bannerInfo.description}</p>
                    <button className={styles.btnPrimary} onClick={() => window.location.pathname = '/contact'}>{bannerInfo.buttonText}</button>
                </div>
                <div className={styles.rightContent}>
                    <img
                        src={bannerInfo.image[currentImage]} 
                        alt={`Banner Image ${currentImage + 1}`} 
                        className={styles.heroImage}
                    />
                </div>
            </div>
        </section>
    );
}
